<template>
  <div
    class="voucher"
    :class="[
      { 'voucher--disabled': data && data.employee && data.employee.status === 'disabled' },
      { 'voucher--active': active }
    ]"
  >
    <header class="voucher__header">
      <div class="voucher__status">
        <span
          class="voucher__status__bullet"
          :class="data && data.voucher && data.voucher.status && `voucher__status__bullet--${data.voucher.status}`"
        />
        <span class="voucher__status__text">
          <span v-if="data && data.employee && data.employee.status === 'disabled'">
            {{ $t(`${namespace}.employeeDisabled`) }}
          </span>
          <span v-else>
            {{ data && data.voucher && data.voucher.status
              ? $t(`${namespace}.voucherStatus.${data.voucher.status}`)
              : $t(`${namespace}.voucherStatus.unmappedStatus`)
            }}
          </span>
        </span>
      </div>

      <div class="voucher__title">
        <span v-if="data && data.employee && data.employee.name">
          <span :title="data.employee.name">{{ data.employee.name }}</span>
        </span>
        <span v-else>-</span>
      </div>
    </header>

    <div class="voucher__body">
      <div class="voucher__item">
        <span class="voucher__item__label">{{ $t('Common.phone') }}</span>
        <span class="voucher__item__text">
          <span v-if="data && data.employee && data.employee.phone && data.employee.phone.number">
            {{ data.employee.phone.number | phone }}
          </span>
          <span v-else>-</span>
        </span>
      </div>

      <div class="voucher__item" >
        <span class="voucher__item__label">{{ $t('Common.company') }}</span>
        <span class="voucher__item__text">
          <span v-if="data && data.company && data.company.name">
            <span :title="data.company.name">{{ data.company.name }}</span>
          </span>
          <span v-else>-</span>
        </span>
      </div>
    </div>

    <footer v-if="isValidObject(data)" class="voucher__footer">
      <a :title="$t(`${namespace}.viewDetails`)" @click.prevent="handleClick(data)">
        {{ $t(`${namespace}.viewDetails`) }}
      </a>
    </footer>
  </div>
</template>

<script>
import { isValidObject } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'VoucherCard',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.SearchPhonePage'
    }
  },
  methods: {
    isValidObject (val) {
      return isValidObject(val)
    },

    handleClick (data) {
      const creditPolicyStatus = data.budget.status === 'enabled' && data.rides.status === 'enabled' ? 'enabled' : 'disabled'

      this.$emit('openDrawer', {
        ...data,
        creditPolicy: {
          status: creditPolicyStatus
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.voucher {
  background-color: var(--white);
  border: 1px solid var(--gray-3);
  border-radius: 4px;
  margin: 12px;
  transition: background .26s, box-shadow .26s;

  &:hover {
    box-shadow: 0 2px 25px 0 rgba(#000, 0.13);
  }

  &.voucher--disabled {

    .voucher__title,
    .voucher__body {
      opacity: .40;
    }
  }

  &.voucher--active {
    background-color: #faf8e9;
  }
}

.voucher__header {
  padding: 16px 16px 0;
}

.voucher__status {
  display: inline-flex;
  margin-bottom: 16px;
}

.voucher__status__bullet {
  background-color: #ccc;
  border-radius: 50%;
  height: 16px;
  margin-right: 8px;
  width: 16px;

  &.voucher__status__bullet--available {
    background-color: #b4ec51;
    background-image: linear-gradient(135deg, #b4ec51, #2dcc70);
  }

  &.voucher__status__bullet--notSynchronized,
  &.voucher__status__bullet--unavailable {
    background-color: $error;
    background-image: linear-gradient(135deg, $error, #9f041b);
  }
}

.voucher__status__text {
  color: var(--gray-7);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.voucher__title {
  color: var(--gray-7);
  display: block;
  font-family: var(--title-font);
  font-size: calc(var(--base-font-size) + 2px);
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.voucher__body {
  padding: 16px;
}

.voucher__item {
  margin-bottom: 8px;
}

.voucher__item__label,
.voucher__item__text {
  display: block;
}

.voucher__item__label {
  color: var(--gray-6);
  font-size: 12px;
  text-transform: capitalize;
}

.voucher__item__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.voucher__footer {
  border-top: 1px solid var(--gray-3);
  text-align: center;
  padding: 12px 0;

  a {
    line-height: 1;
    text-decoration: none;
  }
}
</style>
